import { attr, controller, target, targets } from "@github/catalyst"

// The checkbox dropdown in the claim tickets filter, rendered by
// FilterDropdownComponent. It opens the panel, closes it on Escape or a click
// elsewhere on the page, and keeps the button's summary in step with the boxes
// that are ticked. Every string it shows comes from the server: each box
// carries its own data-label, and the host element carries the "nothing
// picked" label and the "%{count} selected" template.
@controller
class FilterDropdownElement extends HTMLElement {
  @target button!: HTMLButtonElement
  @target panel!: HTMLElement
  @target summary!: HTMLElement
  @targets boxes!: HTMLInputElement[]
  @attr emptyLabel = ""
  @attr countTemplate = ""

  private onDocumentClick = (event: MouseEvent) => {
    if (!this.contains(event.target as Node)) this.close()
  }

  connectedCallback() {
    document.addEventListener("click", this.onDocumentClick)
    // A Turbo cache snapshot may have been taken with the panel open.
    this.close()
    this.update()
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onDocumentClick)
  }

  toggle() {
    this.panel.hidden ? this.open() : this.close()
  }

  open() {
    this.panel.hidden = false
    this.button.setAttribute("aria-expanded", "true")
  }

  close() {
    this.panel.hidden = true
    this.button.setAttribute("aria-expanded", "false")
  }

  keydown(event: KeyboardEvent) {
    if (event.key === "Escape" && !this.panel.hidden) {
      this.close()
      this.button.focus()
    }
  }

  update() {
    const checked = this.boxes.filter((box) => box.checked)
    if (checked.length === 0) {
      this.summary.textContent = this.emptyLabel
    } else if (checked.length === 1) {
      this.summary.textContent = checked[0].getAttribute("data-label")
    } else {
      this.summary.textContent = this.countTemplate.replace("%{count}", String(checked.length))
    }
  }
}

export default FilterDropdownElement
